import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * German Tax ID validator following Single Responsibility Principle
 */
export class DeValidator extends BaseValidator {
  constructor() {
    super({
      name: 'German Tax ID',
      pattern: /^\d{11}$/,
      length: 11
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'German Tax ID must be exactly 11 digits'
    );
  }

  validateChecksum(id) {
    // German Tax ID uses a complex algorithm
    let product = 10;
    
    for (let i = 0; i < 10; i++) {
      let sum = (parseInt(id[i]) + product) % 10;
      if (sum === 0) sum = 10;
      product = (sum * 2) % 11;
    }
    
    const expectedChecksum = 11 - product;
    const actualChecksum = parseInt(id[10]);
    
    if (expectedChecksum === 10 && actualChecksum === 0) {
      return ValidationResult.valid('Valid German Tax ID');
    }
    
    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid German Tax ID checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid German Tax ID');
  }
}